import APIService from "./APIService";

/**
 * API service for AI-powered "How Do I...?" search.
 * Sends the user's natural-language query to the backend, which uses
 * OpenAI to determine intent and return the most relevant help-option IDs.
 */
const HowDoISearchAPI = {
  /**
   * Search help options using AI-powered intent matching.
   * @param {string} query - The user's natural language query
   *   e.g. "I want to change my email address"
   * @returns {Promise<{matchedIds: number[], query: string}>}
   */
  search: async (query) => {
    try {
      const response = await APIService.post("/api/v1/app/howdoi/search", {
        query,
      });
      return response;
    } catch (error) {
      console.error("[HowDoISearchAPI] Error searching:", error);
      throw error;
    }
  },
};

export default HowDoISearchAPI;
